const threeDigitTeaors = [
  {
    labelText: `011 '08 Nem évelő növény termesztése`,
    teaorValue: '011'
  },
  {
    labelText: `012 '08 Évelő növény termesztése`,
    teaorValue: '012'
  },
  {
    labelText: `013 '08 Növényi szaporítóanyag termesztése`,
    teaorValue: '013'
  },
  {
    labelText: `014 '08 Állattenyésztés`,
    teaorValue: '014'
  },
  {
    labelText: `015 '08 Vegyes gazdálkodás`,
    teaorValue: '015'
  },
  {
    labelText: `016 '08 Mezőgazdasági, betakarítást követő szolgáltatás`,
    teaorValue: '016'
  },
  {
    labelText: `017 '08 Vadgazdálkodás, vadgazdálkodási szolgáltatás`,
    teaorValue: '017'
  },
  {
    labelText: `021 '08 Erdészeti, egyéb erdőgazdálkodási tevékenység`,
    teaorValue: '021'
  },
  {
    labelText: `022 '08 Fakitermelés`,
    teaorValue: '022'
  },
  {
    labelText: `023 '08 Vadon termő egyéb erdei termék gyűjtése`,
    teaorValue: '023'
  },
  {
    labelText: `024 '08 Erdészeti szolgáltatás`,
    teaorValue: '024'
  },
  {
    labelText: `031 '08 Halászat`,
    teaorValue: '031'
  },
  {
    labelText: `032 '08 Halgazdálkodás`,
    teaorValue: '032'
  },
  {
    labelText: `051 '08 Feketeszén-bányászat`,
    teaorValue: '051'
  },
  {
    labelText: `052 '08 Barnaszén-, lignitbányászat`,
    teaorValue: '052'
  },
  {
    labelText: `061 '08 Kőolaj-kitermelés`,
    teaorValue: '061'
  },
  {
    labelText: `062 '08 Földgázkitermelés`,
    teaorValue: '062'
  },
  {
    labelText: `071 '08 Vasércbányászat`,
    teaorValue: '071'
  },
  {
    labelText: `072 '08 Egyéb fém érc bányászata`,
    teaorValue: '072'
  },
  {
    labelText: `081 '08 Kőfejtés, homok-, agyagbányászat`,
    teaorValue: '081'
  },
  {
    labelText: `089 '08 M.n.s. bányászat`,
    teaorValue: '089'
  },
  {
    labelText: `091 '08 Kőolaj-, földgáz-kitermelési szolgáltatás`,
    teaorValue: '091'
  },
  {
    labelText: `099 '08 Egyéb bányászati szolgáltatás`,
    teaorValue: '099'
  },
  {
    labelText: `101 '08 Húsfeldolgozás, -tartósítás, húskészítmény gyártása`,
    teaorValue: '101'
  },
  {
    labelText: `102 '08 Halfeldolgozás, -tartósítás`,
    teaorValue: '102'
  },
  {
    labelText: `103 '08 Gyümölcs-, zöldségfeldolgozás, -tartósítás`,
    teaorValue: '103'
  },
  {
    labelText: `104 '08 Növényi, állati olaj gyártása`,
    teaorValue: '104'
  },
  {
    labelText: `105 '08 Tejfeldolgozás`,
    teaorValue: '105'
  },
  {
    labelText: `106 '08 Malomipari termék, keményítő gyártása`,
    teaorValue: '106'
  },
  {
    labelText: `107 '08 Pékáru, tésztafélék gyártása`,
    teaorValue: '107'
  },
  {
    labelText: `108 '08 Egyéb élelmiszer gyártása`,
    teaorValue: '108'
  },
  {
    labelText: `109 '08 Takarmány gyártása`,
    teaorValue: '109'
  },
  {
    labelText: `110 '08 Italgyártás`,
    teaorValue: '110'
  },
  {
    labelText: `120 '08 Dohánytermék gyártása`,
    teaorValue: '120'
  },
  {
    labelText: `131 '08 Textilszálak fonása`,
    teaorValue: '131'
  },
  {
    labelText: `132 '08 Textilszövés`,
    teaorValue: '132'
  },
  {
    labelText: `133 '08 Textilkikészítés`,
    teaorValue: '133'
  },
  {
    labelText: `139 '08 Egyéb textiláru gyártása`,
    teaorValue: '139'
  },
  {
    labelText: `141 '08 Ruházat gyártása (kivéve: szőrmeruházat)`,
    teaorValue: '141'
  },
  {
    labelText: `142 '08 Szőrmecikk gyártása`,
    teaorValue: '142'
  },
  {
    labelText: `143 '08 Kötött, hurkolt cikk gyártása`,
    teaorValue: '143'
  },
  {
    labelText: `151 '08 Bőr, szőrme kikészítése; táskafélék, szíjazat gyártása`,
    teaorValue: '151'
  },
  {
    labelText: `152 '08 Lábbeligyártás`,
    teaorValue: '152'
  },
  {
    labelText: `161 '08 Fűrészárugyártás`,
    teaorValue: '161'
  },
  {
    labelText: `162 '08 Fa-, parafatermék, fonottáru gyártása`,
    teaorValue: '162'
  },
  {
    labelText: `171 '08 Papíripari rostanyag, papír gyártása`,
    teaorValue: '171'
  },
  {
    labelText: `172 '08 Papírtermék gyártása`,
    teaorValue: '172'
  },
  {
    labelText: `181 '08 Nyomdai tevékenység`,
    teaorValue: '181'
  },
  {
    labelText: `182 '08 Egyéb sokszorosítás`,
    teaorValue: '182'
  },
  {
    labelText: `191 '08 Kokszgyártás`,
    teaorValue: '191'
  },
  {
    labelText: `192 '08 Kőolaj-feldolgozás`,
    teaorValue: '192'
  },
  {
    labelText: `201 '08 Vegyi alapanyag gyártása`,
    teaorValue: '201'
  },
  {
    labelText: `202 '08 Mezőgazdasági vegyi termék gyártása`,
    teaorValue: '202'
  },
  {
    labelText: `203 '08 Festék, bevonóanyag gyártása`,
    teaorValue: '203'
  },
  {
    labelText: `204 '08 Tisztítószer, testápolási cikk gyártása`,
    teaorValue: '204'
  },
  {
    labelText: `205 '08 Egyéb vegyi termék gyártása`,
    teaorValue: '205'
  },
  {
    labelText: `206 '08 Vegyi szál gyártása`,
    teaorValue: '206'
  },
  {
    labelText: `211 '08 Gyógyszeralapanyag-gyártás`,
    teaorValue: '211'
  },
  {
    labelText: `212 '08 Gyógyszerkészítmény gyártása`,
    teaorValue: '212'
  },
  {
    labelText: `221 '08 Gumitermék gyártása`,
    teaorValue: '221'
  },
  {
    labelText: `222 '08 Műanyag termék gyártása`,
    teaorValue: '222'
  },
  {
    labelText: `231 '08 Üveg, üvegtermék gyártása`,
    teaorValue: '231'
  },
  {
    labelText: `232 '08 Tűzálló termék gyártása`,
    teaorValue: '232'
  },
  {
    labelText: `233 '08 Kerámia, agyag építőanyag gyártása`,
    teaorValue: '233'
  },
  {
    labelText: `234 '08 Porcelán, kerámiatermék gyártása`,
    teaorValue: '234'
  },
  {
    labelText: `235 '08 Cement-, mész-, gipszgyártás`,
    teaorValue: '235'
  },
  {
    labelText: `236 '08 Beton-, gipsz-, cementtermék gyártása`,
    teaorValue: '236'
  },
  {
    labelText: `237 '08 Kőmegmunkálás`,
    teaorValue: '237'
  },
  {
    labelText: `239 '08 Egyéb csiszolótermék és nemfém ásványi termék gyártása m.n.s.`,
    teaorValue: '239'
  },
  {
    labelText: `241 '08 Vas-, acél-, vasötvözet-alapanyag gyártása`,
    teaorValue: '241'
  },
  {
    labelText: `242 '08 Acélcsőgyártás`,
    teaorValue: '242'
  },
  {
    labelText: `243 '08 Egyéb kohászati termék gyártása acélból`,
    teaorValue: '243'
  },
  {
    labelText: `244 '08 Nem vas fém alapanyag gyártása`,
    teaorValue: '244'
  },
  {
    labelText: `245 '08 Fémöntés`,
    teaorValue: '245'
  },
  {
    labelText: `251 '08 Fémszerkezet, -épületelem gyártása`,
    teaorValue: '251'
  },
  {
    labelText: `252 '08 Fűtési kazán, radiátor, fémtartály gyártása`,
    teaorValue: '252'
  },
  {
    labelText: `253 '08 Gőzkazán gyártása`,
    teaorValue: '253'
  },
  {
    labelText: `254 '08 Fegyver-, lőszergyártás`,
    teaorValue: '254'
  },
  {
    labelText: `255 '08 Fémalakítás, porkohászat`,
    teaorValue: '255'
  },
  {
    labelText: `256 '08 Fém felületkezelése, megmunkálása`,
    teaorValue: '256'
  },
  {
    labelText: `257 '08 Evőeszköz, szerszám, általános fémáru gyártása`,
    teaorValue: '257'
  },
  {
    labelText: `259 '08 Egyéb fémfeldolgozási termék gyártása`,
    teaorValue: '259'
  },
  {
    labelText: `261 '08 Elektronikai alkatrész, áramköri kártya gyártása`,
    teaorValue: '261'
  },
  {
    labelText: `262 '08 Számítógép, perifériás egység gyártása`,
    teaorValue: '262'
  },
  {
    labelText: `263 '08 Híradás-technikai berendezés gyártása`,
    teaorValue: '263'
  },
  {
    labelText: `264 '08 Elektronikus fogyasztási cikk gyártása`,
    teaorValue: '264'
  },
  {
    labelText: `265 '08 Műszer-, óragyártás`,
    teaorValue: '265'
  },
  {
    labelText: `266 '08 Elektronikus orvosi berendezés gyártása`,
    teaorValue: '266'
  },
  {
    labelText: `267 '08 Optikai eszköz gyártása`,
    teaorValue: '267'
  },
  {
    labelText: `268 '08 Mágneses, optikai információhordozó gyártása`,
    teaorValue: '268'
  },
  {
    labelText: `271 '08 Villamos motor, áramfejlesztő, áramelosztó, -szabályozó készülék gyártása`,
    teaorValue: '271'
  },
  {
    labelText: `272 '08 Akkumulátor, szárazelem gyártása`,
    teaorValue: '272'
  },
  {
    labelText: `273 '08 Vezeték, kábel, szerelvény gyártása`,
    teaorValue: '273'
  },
  {
    labelText: `274 '08 Villamos világítóeszköz gyártása`,
    teaorValue: '274'
  },
  {
    labelText: `275 '08 Háztartási készülék gyártása`,
    teaorValue: '275'
  },
  {
    labelText: `279 '08 Egyéb villamos berendezés gyártása`,
    teaorValue: '279'
  },
  {
    labelText: `281 '08 Általános rendeltetésű gép gyártása`,
    teaorValue: '281'
  },
  {
    labelText: `282 '08 Egyéb általános rendeltetésű gép gyártása`,
    teaorValue: '282'
  },
  {
    labelText: `283 '08 Mezőgazdasági, erdészeti gép gyártása`,
    teaorValue: '283'
  },
  {
    labelText: `284 '08 Szerszámgépgyártás`,
    teaorValue: '284'
  },
  {
    labelText: `289 '08 Egyéb speciális rendeltetésű gép gyártása`,
    teaorValue: '289'
  },
  {
    labelText: `291 '08 Közúti gépjármű gyártása`,
    teaorValue: '291'
  },
  {
    labelText: `292 '08 Gépjármű-karosszéria, pótkocsi gyártása`,
    teaorValue: '292'
  },
  {
    labelText: `293 '08 Közúti jármű alkatrészeinek gyártása`,
    teaorValue: '293'
  },
  {
    labelText: `301 '08 Hajó, csónak gyártása`,
    teaorValue: '301'
  },
  {
    labelText: `302 '08 Vasúti, kötöttpályás jármű gyártása`,
    teaorValue: '302'
  },
  {
    labelText: `303 '08 Légi, űrjármű gyártása`,
    teaorValue: '303'
  },
  {
    labelText: `304 '08 Katonai harcjármű gyártása`,
    teaorValue: '304'
  },
  {
    labelText: `309 '08 Egyéb jármű gyártása`,
    teaorValue: '309'
  },
  {
    labelText: `310 '08 Bútorgyártás`,
    teaorValue: '310'
  },
  {
    labelText: `321 '08 Ékszergyártás`,
    teaorValue: '321'
  },
  {
    labelText: `322 '08 Hangszergyártás`,
    teaorValue: '322'
  },
  {
    labelText: `323 '08 Sportszergyártás`,
    teaorValue: '323'
  },
  {
    labelText: `324 '08 Játékgyártás`,
    teaorValue: '324'
  },
  {
    labelText: `325 '08 Orvosi eszköz gyártása`,
    teaorValue: '325'
  },
  {
    labelText: `329 '08 M.n.s. egyéb feldolgozóipari tevékenység`,
    teaorValue: '329'
  },
  {
    labelText: `331 '08 Ipari gép, berendezés, eszköz javítása`,
    teaorValue: '331'
  },
  {
    labelText: `332 '08 Ipari gép, berendezés üzembe helyezése`,
    teaorValue: '332'
  },
  {
    labelText: `351 '08 Villamosenergia-termelés, -ellátás`,
    teaorValue: '351'
  },
  {
    labelText: `352 '08 Gázellátás`,
    teaorValue: '352'
  },
  {
    labelText: `353 '08 Gőzellátás, légkondicionálás`,
    teaorValue: '353'
  },
  {
    labelText: `360 '08 Víztermelés, -kezelés, -ellátás`,
    teaorValue: '360'
  },
  {
    labelText: `370 '08 Szennyvíz gyűjtése, kezelése`,
    teaorValue: '370'
  },
  {
    labelText: `381 '08 Hulladékgyűjtés`,
    teaorValue: '381'
  },
  {
    labelText: `382 '08 Hulladékkezelés, -ártalmatlanítás`,
    teaorValue: '382'
  },
  {
    labelText: `383 '08 Hulladékanyag hasznosítása`,
    teaorValue: '383'
  },
  {
    labelText: `390 '08 Szennyeződésmentesítés, egyéb hulladékkezelés`,
    teaorValue: '390'
  },
  {
    labelText: `411 '08 Épületépítési projekt szervezése`,
    teaorValue: '411'
  },
  {
    labelText: `412 '08 Lakó- és nem lakó épület építése`,
    teaorValue: '412'
  },
  {
    labelText: `421 '08 Út, vasút építése`,
    teaorValue: '421'
  },
  {
    labelText: `422 '08 Közműépítés`,
    teaorValue: '422'
  },
  {
    labelText: `429 '08 M.n.s. egyéb építmény építése`,
    teaorValue: '429'
  },
  {
    labelText: `431 '08 Bontás, építési terület előkészítése`,
    teaorValue: '431'
  },
  {
    labelText: `432 '08 Épületgépészeti szerelés`,
    teaorValue: '432'
  },
  {
    labelText: `433 '08 Befejező építés`,
    teaorValue: '433'
  },
  {
    labelText: `439 '08 Egyéb speciális szaképítés`,
    teaorValue: '439'
  },
  {
    labelText: `451 '08 Gépjármű-kereskedelem`,
    teaorValue: '451'
  },
  {
    labelText: `452 '08 Gépjárműjavítás, -karbantartás`,
    teaorValue: '452'
  },
  {
    labelText: `453 '08 Gépjárműalkatrész-kereskedelem`,
    teaorValue: '453'
  },
  {
    labelText: `454 '08 Motorkerékpár, -alkatrész kereskedelme, javítása`,
    teaorValue: '454'
  },
  {
    labelText: `461 '08 Ügynöki nagykereskedelem`,
    teaorValue: '461'
  },
  {
    labelText: `462 '08 Mezőgazdasági nyersanyag, élőállat nagykereskedelme`,
    teaorValue: '462'
  },
  {
    labelText: `463 '08 Élelmiszer, ital, dohányáru nagykereskedelme`,
    teaorValue: '463'
  },
  {
    labelText: `464 '08 Háztartási cikk nagykereskedelme`,
    teaorValue: '464'
  },
  {
    labelText: `465 '08 Információtechnológiai, híradás-technikai termék nagykereskedelme`,
    teaorValue: '465'
  },
  {
    labelText: `466 '08 Egyéb gép, berendezés, tartozék nagykereskedelme`,
    teaorValue: '466'
  },
  {
    labelText: `467 '08 Egyéb szakosodott nagykereskedelem`,
    teaorValue: '467'
  },
  {
    labelText: `469 '08 Vegyestermékkörű nagykereskedelem`,
    teaorValue: '469'
  },
  {
    labelText: `471 '08 Nem szakosodott bolti vegyes kiskereskedelem`,
    teaorValue: '471'
  },
  {
    labelText: `472 '08 Élelmiszer-, ital-, dohányáru kiskereskedelme`,
    teaorValue: '472'
  },
  {
    labelText: `473 '08 Gépjárműüzemanyag-kiskereskedelem`,
    teaorValue: '473'
  },
  {
    labelText: `474 '08 Információs, híradás-technikai termék kiskereskedelme`,
    teaorValue: '474'
  },
  {
    labelText: `475 '08 Egyéb háztartási cikk kiskereskedelme`,
    teaorValue: '475'
  },
  {
    labelText: `476 '08 Kulturális, szabadidős cikk bolti kiskereskedelme`,
    teaorValue: '476'
  },
  {
    labelText: `477 '08 Egyéb m.n.s. áru kiskereskedelme`,
    teaorValue: '477'
  },
  {
    labelText: `478 '08 Piaci kiskereskedelem`,
    teaorValue: '478'
  },
  {
    labelText: `479 '08 Nem bolti, piaci kiskereskedelem`,
    teaorValue: '479'
  },
  {
    labelText: `491 '08 Helyközi vasúti személyszállítás`,
    teaorValue: '491'
  },
  {
    labelText: `492 '08 Vasúti áruszállítás`,
    teaorValue: '492'
  },
  {
    labelText: `493 '08 Egyéb szárazföldi személyszállítás`,
    teaorValue: '493'
  },
  {
    labelText: `494 '08 Közúti áruszállítás, költöztetés`,
    teaorValue: '494'
  },
  {
    labelText: `495 '08 Csővezetékes szállítás`,
    teaorValue: '495'
  },
  {
    labelText: `501 '08 Tengeri személyszállítás`,
    teaorValue: '501'
  },
  {
    labelText: `502 '08 Tengeri áruszállítás`,
    teaorValue: '502'
  },
  {
    labelText: `503 '08 Belvízi személyszállítás`,
    teaorValue: '503'
  },
  {
    labelText: `504 '08 Belvízi áruszállítás`,
    teaorValue: '504'
  },
  {
    labelText: `511 '08 Légi személyszállítás`,
    teaorValue: '511'
  },
  {
    labelText: `512 '08 Légi áruszállítás`,
    teaorValue: '512'
  },
  {
    labelText: `521 '08 Raktározás, tárolás`,
    teaorValue: '521'
  },
  {
    labelText: `522 '08 Szállítást kiegészítő tevékenység`,
    teaorValue: '522'
  },
  {
    labelText: `531 '08 Postai tevékenység (egyetemes kötelezettséggel)`,
    teaorValue: '531'
  },
  {
    labelText: `532 '08 Egyéb postai, futárpostai tevékenység`,
    teaorValue: '532'
  },
  {
    labelText: `551 '08 Szállodai szolgáltatás`,
    teaorValue: '551'
  },
  {
    labelText: `552 '08 Üdülési, egyéb átmeneti szálláshely-szolgáltatás`,
    teaorValue: '552'
  },
  {
    labelText: `553 '08 Kempingszolgáltatás`,
    teaorValue: '553'
  },
  {
    labelText: `559 '08 Egyéb szálláshely-szolgáltatás`,
    teaorValue: '559'
  },
  {
    labelText: `561 '08 Éttermi, mozgó vendéglátás`,
    teaorValue: '561'
  },
  {
    labelText: `562 '08 Rendezvényi étkeztetés és egyéb vendéglátás`,
    teaorValue: '562'
  },
  {
    labelText: `563 '08 Italszolgáltatás`,
    teaorValue: '563'
  },
  {
    labelText: `581 '08 Kiadói tevékenység`,
    teaorValue: '581'
  },
  {
    labelText: `582 '08 Szoftverkiadás`,
    teaorValue: '582'
  },
  {
    labelText: `591 '08 Film-, video-, televízióműsor-gyártás`,
    teaorValue: '591'
  },
  {
    labelText: `592 '08 Hangfelvétel készítése, kiadása`,
    teaorValue: '592'
  },
  {
    labelText: `601 '08 Rádióműsor-szolgáltatás`,
    teaorValue: '601'
  },
  {
    labelText: `602 '08 Televízióműsor összeállítása, szolgáltatása`,
    teaorValue: '602'
  },
  {
    labelText: `611 '08 Vezetékes távközlés`,
    teaorValue: '611'
  },
  {
    labelText: `612 '08 Vezeték nélküli távközlés`,
    teaorValue: '612'
  },
  {
    labelText: `613 '08 Műholdas távközlés`,
    teaorValue: '613'
  },
  {
    labelText: `619 '08 Egyéb távközlés`,
    teaorValue: '619'
  },
  {
    labelText: `620 '08 Információ-technológiai szolgáltatás`,
    teaorValue: '620'
  },
  {
    labelText: `631 '08 Adatfeldolgozás, web-hoszting, világháló-portál szolgáltatás`,
    teaorValue: '631'
  },
  {
    labelText: `639 '08 Egyéb információs szolgáltatás`,
    teaorValue: '639'
  },
  {
    labelText: `641 '08 Monetáris közvetítés`,
    teaorValue: '641'
  },
  {
    labelText: `642 '08 Vagyonkezelés (holding)`,
    teaorValue: '642'
  },
  {
    labelText: `643 '08 Befektetési alapok és hasonlók`,
    teaorValue: '643'
  },
  {
    labelText: `649 '08 Egyéb pénzügyi közvetítés`,
    teaorValue: '649'
  },
  {
    labelText: `651 '08 Biztosítás`,
    teaorValue: '651'
  },
  {
    labelText: `652 '08 Viszontbiztosítás`,
    teaorValue: '652'
  },
  {
    labelText: `653 '08 Nyugdíjalapok`,
    teaorValue: '653'
  },
  {
    labelText: `661 '08 Pénzügyi kiegészítő tevékenység (kivéve: biztosítás, nyugdíjalap)`,
    teaorValue: '661'
  },
  {
    labelText: `662 '08 Biztosítást, nyugdíjalapot kiegészítő tevékenység`,
    teaorValue: '662'
  },
  {
    labelText: `663 '08 Alapkezelés`,
    teaorValue: '663'
  },
  {
    labelText: `681 '08 Saját tulajdonú ingatlan adásvétele`,
    teaorValue: '681'
  },
  {
    labelText: `682 '08 Saját tulajdonú, bérelt ingatlan bérbeadása, üzemeltetése`,
    teaorValue: '682'
  },
  {
    labelText: `683 '08 Ingatlanügynöki, -kezelési szolgáltatás`,
    teaorValue: '683'
  },
  {
    labelText: `691 '08 Jogi tevékenység`,
    teaorValue: '691'
  },
  {
    labelText: `692 '08 Számviteli, könyvvizsgálói, adószakértői tevékenység`,
    teaorValue: '692'
  },
  {
    labelText: `701 '08 Üzletvezetés`,
    teaorValue: '701'
  },
  {
    labelText: `702 '08 Üzletviteli tanácsadás`,
    teaorValue: '702'
  },
  {
    labelText: `711 '08 Építészmérnöki tevékenység; műszaki vizsgálat, elemzés`,
    teaorValue: '711'
  },
  {
    labelText: `712 '08 Műszaki vizsgálat, elemzés`,
    teaorValue: '712'
  },
  {
    labelText: `721 '08 Természettudományi, műszaki kutatás, fejlesztés`,
    teaorValue: '721'
  },
  {
    labelText: `722 '08 Társadalomtudományi, humán kutatás, fejlesztés`,
    teaorValue: '722'
  },
  {
    labelText: `731 '08 Reklám`,
    teaorValue: '731'
  },
  {
    labelText: `732 '08 Piac-, közvélemény-kutatás`,
    teaorValue: '732'
  },
  {
    labelText: `741 '08 Divat-, formatervezés`,
    teaorValue: '741'
  },
  {
    labelText: `742 '08 Fényképészet`,
    teaorValue: '742'
  },
  {
    labelText: `743 '08 Fordítás, tolmácsolás`,
    teaorValue: '743'
  },
  {
    labelText: `749 '08 M.n.s. egyéb szakmai, tudományos, műszaki tevékenység`,
    teaorValue: '749'
  },
  {
    labelText: `750 '08 Állat-egészségügyi ellátás`,
    teaorValue: '750'
  },
  {
    labelText: `771 '08 Gépjárműkölcsönzés`,
    teaorValue: '771'
  },
  {
    labelText: `772 '08 Személyi használatú, háztartási cikk kölcsönzése`,
    teaorValue: '772'
  },
  {
    labelText: `773 '08 Egyéb gép, tárgyi eszköz kölcsönzése`,
    teaorValue: '773'
  },
  {
    labelText: `774 '08 Immateriális javak kölcsönzése`,
    teaorValue: '774'
  },
  {
    labelText: `781 '08 Munkaközvetítés`,
    teaorValue: '781'
  },
  {
    labelText: `782 '08 Munkaerőkölcsönzés`,
    teaorValue: '782'
  },
  {
    labelText: `783 '08 Egyéb emberierőforrás-ellátás, -gazdálkodás`,
    teaorValue: '783'
  },
  {
    labelText: `791 '08 Utazásközvetítés, utazásszervezés`,
    teaorValue: '791'
  },
  {
    labelText: `799 '08 Egyéb foglalás`,
    teaorValue: '799'
  },
  {
    labelText: `801 '08 Személybiztonsági tevékenység`,
    teaorValue: '801'
  },
  {
    labelText: `802 '08 Biztonsági rendszer szolgáltatás`,
    teaorValue: '802'
  },
  {
    labelText: `803 '08 Nyomozás`,
    teaorValue: '803'
  },
  {
    labelText: `811 '08 Építményüzemeltetés`,
    teaorValue: '811'
  },
  {
    labelText: `812 '08 Takarítás`,
    teaorValue: '812'
  },
  {
    labelText: `813 '08 Zöldterület-kezelés`,
    teaorValue: '813'
  },
  {
    labelText: `821 '08 Adminisztratív, kiegészítő szolgáltatás`,
    teaorValue: '821'
  },
  {
    labelText: `822 '08 Telefoninformáció`,
    teaorValue: '822'
  },
  {
    labelText: `823 '08 Konferencia, kereskedelmi bemutató szervezése`,
    teaorValue: '823'
  },
  {
    labelText: `829 '08 Egyéb kiegészítő gazdasági tevékenység`,
    teaorValue: '829'
  },
  {
    labelText: `841 '08 Közigazgatás`,
    teaorValue: '841'
  },
  {
    labelText: `842 '08 Társadalmi közszolgáltatás`,
    teaorValue: '842'
  },
  {
    labelText: `843 '08 Kötelező társadalombiztosítás`,
    teaorValue: '843'
  },
  {
    labelText: `851 '08 Iskolai előkészítő oktatás`,
    teaorValue: '851'
  },
  {
    labelText: `852 '08 Alapfokú oktatás`,
    teaorValue: '852'
  },
  {
    labelText: `853 '08 Középfokú oktatás`,
    teaorValue: '853'
  },
  {
    labelText: `854 '08 Felső szintű oktatás`,
    teaorValue: '854'
  },
  {
    labelText: `855 '08 Egyéb oktatás`,
    teaorValue: '855'
  },
  {
    labelText: `856 '08 Oktatást kiegészítő tevékenység`,
    teaorValue: '856'
  },
  {
    labelText: `861 '08 Fekvőbeteg-ellátás`,
    teaorValue: '861'
  },
  {
    labelText: `862 '08 Járóbeteg-ellátás, fogorvosi ellátás`,
    teaorValue: '862'
  },
  {
    labelText: `869 '08 Egyéb humán-egészségügyi ellátás`,
    teaorValue: '869'
  },
  {
    labelText: `871 '08 Bentlakásos, nem kórházi ápolás`,
    teaorValue: '871'
  },
  {
    labelText: `872 '08 Mentális, szenvedélybeteg bentlakásos ellátása`,
    teaorValue: '872'
  },
  {
    labelText: `873 '08 Idősek, fogyatékosok bentlakásos ellátása`,
    teaorValue: '873'
  },
  {
    labelText: `879 '08 Egyéb bentlakásos ellátás`,
    teaorValue: '879'
  },
  {
    labelText: `881 '08 Idősek, fogyatékosok szociális ellátása bentlakás nélkül`,
    teaorValue: '881'
  },
  {
    labelText: `889 '08 Egyéb szociális ellátás bentlakás nélkül`,
    teaorValue: '889'
  },
  {
    labelText: `900 '08 Alkotó-, művészeti, szórakoztató tevékenység`,
    teaorValue: '900'
  },
  {
    labelText: `910 '08 Könyvtári, levéltári, múzeumi, egyéb kulturális tevékenység`,
    teaorValue: '910'
  },
  {
    labelText: `920 '08 Szerencsejáték, fogadás`,
    teaorValue: '920'
  },
  {
    labelText: `931 '08 Sporttevékenység`,
    teaorValue: '931'
  },
  {
    labelText: `932 '08 Egyéb szórakoztatás, szabadidős tevékenység`,
    teaorValue: '932'
  },
  {
    labelText: `941 '08 Vállalkozói, szakmai érdekképviselet`,
    teaorValue: '941'
  },
  {
    labelText: `942 '08 Szakszervezeti tevékenység`,
    teaorValue: '942'
  },
  {
    labelText: `949 '08 Egyéb közösségi, társadalmi tevékenység`,
    teaorValue: '949'
  },
  {
    labelText: `951 '08 Számítógép, kommunikációs eszköz javítása`,
    teaorValue: '951'
  },
  {
    labelText: `952 '08 Személyi, háztartási cikk javítása`,
    teaorValue: '952'
  },
  {
    labelText: `960 '08 Egyéb személyi szolgáltatás`,
    teaorValue: '960'
  },
  {
    labelText: `970 '08 Háztartási alkalmazottat foglalkoztató magánháztartás`,
    teaorValue: '970'
  },
  {
    labelText: `981 '08 Háztartás termék-előállítása, szolgáltatása saját fogyasztásra`,
    teaorValue: '981'
  },
  {
    labelText: `982 '08 Háztartás szolgáltatása saját fogyasztásra`,
    teaorValue: '982'
  }
]

export default threeDigitTeaors
